// This file is auto-generated by @hey-api/openapi-ts

import type { ExportsParticipantsExportMultipleRetrieveResponse, ExportsParticipantsExportRetrieveResponse, GestionnaireMeetingsListResponse, GestionnaireMeetingsMyParticipationRetrieveResponse, GestionnaireMeetingsMyScopeListListResponse, GestionnaireMeetingsPartialUpdateResponse, GestionnaireMeetingsRetrieveResponse, GestionnaireMeetingsSyncAvisTagadaCreateResponse, GestionnaireMeetingsSyncParticipantsTagadaCreateResponse, GestionnaireMeetingsUpdateResponse, GestionnaireParticipantsListResponse, GestionnaireParticipantsPartialUpdateResponse, GestionnaireParticipantsRetrieveResponse, GestionnaireParticipantsUpdateResponse, MediaRetrieveResponse, MeetingsDailyTaskTeamsTeamDailyTasksListResponse, MeetingsDailyTaskTeamsTeamDailyTasksRetrieveResponse, MeetingsEventsApplyTypicalDayCreateResponse, MeetingsEventsChildrenCreateResponse, MeetingsEventsChildrenRetrieveResponse, MeetingsEventsCopyToDaysCreateResponse, MeetingsEventsCreateResponse, MeetingsEventsEnrollmentCreateResponse, MeetingsEventsEnrollmentListResponse, MeetingsEventsEnrollmentsListResponse, MeetingsEventsInChargeListResponse, MeetingsEventsListResponse, MeetingsEventsModularListResponse, MeetingsEventsMyDailyEventsListResponse, MeetingsEventsMyEnrollmentCreateResponse, MeetingsEventsMyEnrollmentRetrieveResponse, MeetingsEventsMyEnrollmentsListResponse, MeetingsEventsOwnPlanningListResponse, MeetingsEventsPartialUpdateResponse, MeetingsEventsPlanningRetrieveResponse, MeetingsEventsPublicListListResponse, MeetingsEventsPublicModularListResponse, MeetingsEventsRetrieveResponse, MeetingsEventsSupervisorListResponse, MeetingsEventsTypicalDayListResponse, MeetingsEventsUpdateResponse, MeetingsEventsWithActivityApplyTypicalDayCreateResponse, MeetingsEventsWithActivityChildrenCreateResponse, MeetingsEventsWithActivityChildrenRetrieveResponse, MeetingsEventsWithActivityCopyToDaysCreateResponse, MeetingsEventsWithActivityCreateResponse, MeetingsEventsWithActivityEnrollmentCreateResponse, MeetingsEventsWithActivityEnrollmentListResponse, MeetingsEventsWithActivityEnrollmentsListResponse, MeetingsEventsWithActivityInChargeListResponse, MeetingsEventsWithActivityListResponse, MeetingsEventsWithActivityMyDailyEventsListResponse, MeetingsEventsWithActivityMyEnrollmentCreateResponse, MeetingsEventsWithActivityMyEnrollmentRetrieveResponse, MeetingsEventsWithActivityMyEnrollmentsListResponse, MeetingsEventsWithActivityOwnPlanningListResponse, MeetingsEventsWithActivityPartialUpdateResponse, MeetingsEventsWithActivityPlanningRetrieveResponse, MeetingsEventsWithActivityPublicListListResponse, MeetingsEventsWithActivityRetrieveResponse, MeetingsEventsWithActivitySupervisorListResponse, MeetingsEventsWithActivityTypicalDayListResponse, MeetingsEventsWithActivityUpdateResponse, MeetingsFormsCreateResponse, MeetingsFormsExportSubmissionsRetrieveResponse, MeetingsFormsListResponse, MeetingsFormsPartialUpdateResponse, MeetingsFormsPublicListResponse, MeetingsFormsPublicRetrieveResponse, MeetingsFormsPublishCreateResponse, MeetingsFormsRetrieveResponse, MeetingsFormsSubmissionsCreateResponse, MeetingsFormsSubmissionsListResponse, MeetingsFormsSubmissionsPartialUpdateResponse, MeetingsFormsSubmissionsRetrieveResponse, MeetingsFormsSubmissionsUpdateResponse, MeetingsFormsUpdateResponse, MeetingsListResponse, MeetingsMyParticipationRetrieveResponse, MeetingsParticipantsAvatarMediaRetrieveResponse, MeetingsParticipantsAvatarMediaUpdateResponse, MeetingsParticipantsCommentsCreateResponse, MeetingsParticipantsCommentsListResponse, MeetingsParticipantsCommentsPartialUpdateResponse, MeetingsParticipantsCommentsRetrieveResponse, MeetingsParticipantsCommentsUpdateResponse, MeetingsParticipantsListResponse, MeetingsParticipantsOpinionListListResponse, MeetingsParticipantsOpinionPartialUpdateResponse, MeetingsParticipantsOpinionRetrieveResponse, MeetingsParticipantsOpinionUpdateResponse, MeetingsParticipantsPartialUpdateResponse, MeetingsParticipantsRetrieveResponse, MeetingsParticipantsSignatureMediaRetrieveResponse, MeetingsParticipantsSignatureMediaUpdateResponse, MeetingsParticipantsUpdateResponse, MeetingsPublicListResponse, MeetingsPublicRetrieveResponse, MeetingsResourcesCreateResponse, MeetingsResourcesPartialUpdateResponse, MeetingsResourcesPublicCreateResponse, MeetingsResourcesPublicPartialUpdateResponse, MeetingsResourcesPublicResourceMediaRetrieveResponse, MeetingsResourcesPublicResourceMediaUpdateResponse, MeetingsResourcesPublicRetrieveResponse, MeetingsResourcesPublicTreeRetrieveResponse, MeetingsResourcesPublicUpdateResponse, MeetingsResourcesResourceMediaRetrieveResponse, MeetingsResourcesResourceMediaUpdateResponse, MeetingsResourcesRetrieveResponse, MeetingsResourcesTreeRetrieveResponse, MeetingsResourcesUpdateResponse, MeetingsRetrieveResponse, MeetingsSyncAvisTagadaCreateResponse, MeetingsSyncParticipantsTagadaCreateResponse, MeetingsTableExportsParticipantListDirectionRetrieveResponse, MeetingsTableExportsParticipantListRetrieveResponse, MeetingsTableExportsProcesVerbalRetrieveResponse, MeetingsTableExportsTeamsdailytasksbytaskRetrieveResponse, MeetingsTableExportsTeamsdailytasksbyteamRetrieveResponse, MeetingsTeamDailyTasksCreateResponse, MeetingsTeamDailyTasksListResponse, MeetingsTeamDailyTasksPartialUpdateResponse, MeetingsTeamDailyTasksRetrieveResponse, MeetingsTeamDailyTasksUpdateResponse, ParticipantsExportsProcesVerbalRetrieveResponse, UsersAvatarMediaRetrieveResponse, UsersAvatarMediaUpdateResponse, UsersDiplomasCreateResponse, UsersDiplomasDiplomaMediaRetrieveResponse, UsersDiplomasDiplomaMediaUpdateResponse, UsersDiplomasListResponse, UsersDiplomasPartialUpdateResponse, UsersDiplomasRetrieveResponse, UsersDiplomasUpdateResponse, UsersMeRetrieveResponse, UsersRetrieveResponse, UsersSignatureMediaRetrieveResponse, UsersSignatureMediaUpdateResponse, WebhooksCronMeetingCreateResponse, WebhooksCronMeetingParticipantCreateResponse } from './types.gen';

const notNestedDiplomaSchemaResponseTransformer = (data: any) => {
    data.issue_date = new Date(data.issue_date);
    return data;
};

const notNestedUserSchemaResponseTransformer = (data: any) => {
    if (data.birthdate) {
        data.birthdate = new Date(data.birthdate);
    }
    data.diplomas = data.diplomas.map((item: any) => notNestedDiplomaSchemaResponseTransformer(item));
    if (data.last_sync) {
        data.last_sync = new Date(data.last_sync);
    }
    return data;
};

const meetingParticipantSchemaResponseTransformer = (data: any) => {
    data.created = new Date(data.created);
    data.updated = new Date(data.updated);
    data.user = notNestedUserSchemaResponseTransformer(data.user);
    if (data.birthdate) {
        data.birthdate = new Date(data.birthdate);
    }
    if (data.tagada_avis_last_sync) {
        data.tagada_avis_last_sync = new Date(data.tagada_avis_last_sync);
    }
    data.intranet_last_sync = new Date(data.intranet_last_sync);
    if (data.user_last_sync) {
        data.user_last_sync = new Date(data.user_last_sync);
    }
    if (data.rg_user) {
        data.rg_user = notNestedUserSchemaResponseTransformer(data.rg_user);
    }
    if (data.dt_user) {
        data.dt_user = notNestedUserSchemaResponseTransformer(data.dt_user);
    }
    return data;
};

export const exportsParticipantsExportRetrieveResponseTransformer = async (data: any): Promise<ExportsParticipantsExportRetrieveResponse> => {
    data = meetingParticipantSchemaResponseTransformer(data);
    return data;
};

export const exportsParticipantsExportMultipleRetrieveResponseTransformer = async (data: any): Promise<ExportsParticipantsExportMultipleRetrieveResponse> => {
    data = meetingParticipantSchemaResponseTransformer(data);
    return data;
};

const meetingSchemaResponseTransformer = (data: any) => {
    data.created_at = new Date(data.created_at);
    data.end_date = new Date(data.end_date);
    data.start_date = new Date(data.start_date);
    data.updated_at = new Date(data.updated_at);
    if (data.tagada_participants_last_sync) {
        data.tagada_participants_last_sync = new Date(data.tagada_participants_last_sync);
    }
    if (data.tagada_avis_last_sync) {
        data.tagada_avis_last_sync = new Date(data.tagada_avis_last_sync);
    }
    data.intranet_last_sync = new Date(data.intranet_last_sync);
    return data;
};

const paginatedMeetingListSchemaResponseTransformer = (data: any) => {
    data.results = data.results.map((item: any) => meetingSchemaResponseTransformer(item));
    return data;
};

export const gestionnaireMeetingsListResponseTransformer = async (data: any): Promise<GestionnaireMeetingsListResponse> => {
    data = paginatedMeetingListSchemaResponseTransformer(data);
    return data;
};

const meetingGestionnaireSchemaResponseTransformer = (data: any) => {
    data.created_at = new Date(data.created_at);
    data.end_date = new Date(data.end_date);
    data.start_date = new Date(data.start_date);
    data.updated_at = new Date(data.updated_at);
    if (data.tagada_participants_last_sync) {
        data.tagada_participants_last_sync = new Date(data.tagada_participants_last_sync);
    }
    if (data.tagada_avis_last_sync) {
        data.tagada_avis_last_sync = new Date(data.tagada_avis_last_sync);
    }
    data.intranet_last_sync = new Date(data.intranet_last_sync);
    return data;
};

export const gestionnaireMeetingsRetrieveResponseTransformer = async (data: any): Promise<GestionnaireMeetingsRetrieveResponse> => {
    data = meetingGestionnaireSchemaResponseTransformer(data);
    return data;
};

export const gestionnaireMeetingsPartialUpdateResponseTransformer = async (data: any): Promise<GestionnaireMeetingsPartialUpdateResponse> => {
    data = meetingGestionnaireSchemaResponseTransformer(data);
    return data;
};

export const gestionnaireMeetingsUpdateResponseTransformer = async (data: any): Promise<GestionnaireMeetingsUpdateResponse> => {
    data = meetingGestionnaireSchemaResponseTransformer(data);
    return data;
};

const ownMeetingParticipantSchemaResponseTransformer = (data: any) => {
    if (data.birthdate) {
        data.birthdate = new Date(data.birthdate);
    }
    if (data.last_sync) {
        data.last_sync = new Date(data.last_sync);
    }
    return data;
};

export const gestionnaireMeetingsMyParticipationRetrieveResponseTransformer = async (data: any): Promise<GestionnaireMeetingsMyParticipationRetrieveResponse> => {
    data = ownMeetingParticipantSchemaResponseTransformer(data);
    return data;
};

export const gestionnaireMeetingsSyncAvisTagadaCreateResponseTransformer = async (data: any): Promise<GestionnaireMeetingsSyncAvisTagadaCreateResponse> => {
    data = meetingSchemaResponseTransformer(data);
    return data;
};

export const gestionnaireMeetingsSyncParticipantsTagadaCreateResponseTransformer = async (data: any): Promise<GestionnaireMeetingsSyncParticipantsTagadaCreateResponse> => {
    data = meetingSchemaResponseTransformer(data);
    return data;
};

export const gestionnaireMeetingsMyScopeListListResponseTransformer = async (data: any): Promise<GestionnaireMeetingsMyScopeListListResponse> => {
    data = paginatedMeetingListSchemaResponseTransformer(data);
    return data;
};

const paginatedMeetingParticipantListSchemaResponseTransformer = (data: any) => {
    data.results = data.results.map((item: any) => meetingParticipantSchemaResponseTransformer(item));
    return data;
};

export const gestionnaireParticipantsListResponseTransformer = async (data: any): Promise<GestionnaireParticipantsListResponse> => {
    data = paginatedMeetingParticipantListSchemaResponseTransformer(data);
    return data;
};

export const gestionnaireParticipantsRetrieveResponseTransformer = async (data: any): Promise<GestionnaireParticipantsRetrieveResponse> => {
    data = meetingParticipantSchemaResponseTransformer(data);
    return data;
};

export const gestionnaireParticipantsPartialUpdateResponseTransformer = async (data: any): Promise<GestionnaireParticipantsPartialUpdateResponse> => {
    data = meetingParticipantSchemaResponseTransformer(data);
    return data;
};

export const gestionnaireParticipantsUpdateResponseTransformer = async (data: any): Promise<GestionnaireParticipantsUpdateResponse> => {
    data = meetingParticipantSchemaResponseTransformer(data);
    return data;
};

const mediaSchemaResponseTransformer = (data: any) => {
    data.created_date = new Date(data.created_date);
    data.updated_date = new Date(data.updated_date);
    return data;
};

export const mediaRetrieveResponseTransformer = async (data: any): Promise<MediaRetrieveResponse> => {
    data = mediaSchemaResponseTransformer(data);
    return data;
};

export const meetingsListResponseTransformer = async (data: any): Promise<MeetingsListResponse> => {
    data = paginatedMeetingListSchemaResponseTransformer(data);
    return data;
};

const meetingPublicSchemaResponseTransformer = (data: any) => {
    data.created_at = new Date(data.created_at);
    data.end_date = new Date(data.end_date);
    data.start_date = new Date(data.start_date);
    data.updated_at = new Date(data.updated_at);
    return data;
};

const paginatedMeetingPublicListSchemaResponseTransformer = (data: any) => {
    data.results = data.results.map((item: any) => meetingPublicSchemaResponseTransformer(item));
    return data;
};

export const meetingsPublicListResponseTransformer = async (data: any): Promise<MeetingsPublicListResponse> => {
    data = paginatedMeetingPublicListSchemaResponseTransformer(data);
    return data;
};

export const meetingsPublicRetrieveResponseTransformer = async (data: any): Promise<MeetingsPublicRetrieveResponse> => {
    data = meetingPublicSchemaResponseTransformer(data);
    return data;
};

export const meetingsRetrieveResponseTransformer = async (data: any): Promise<MeetingsRetrieveResponse> => {
    data = meetingSchemaResponseTransformer(data);
    return data;
};

export const meetingsMyParticipationRetrieveResponseTransformer = async (data: any): Promise<MeetingsMyParticipationRetrieveResponse> => {
    data = ownMeetingParticipantSchemaResponseTransformer(data);
    return data;
};

export const meetingsSyncAvisTagadaCreateResponseTransformer = async (data: any): Promise<MeetingsSyncAvisTagadaCreateResponse> => {
    data = meetingSchemaResponseTransformer(data);
    return data;
};

export const meetingsSyncParticipantsTagadaCreateResponseTransformer = async (data: any): Promise<MeetingsSyncParticipantsTagadaCreateResponse> => {
    data = meetingSchemaResponseTransformer(data);
    return data;
};

const teamDailyTaskSchemaResponseTransformer = (data: any) => {
    data.date = new Date(data.date);
    return data;
};

const paginatedTeamDailyTaskListSchemaResponseTransformer = (data: any) => {
    data.results = data.results.map((item: any) => teamDailyTaskSchemaResponseTransformer(item));
    return data;
};

export const meetingsDailyTaskTeamsTeamDailyTasksListResponseTransformer = async (data: any): Promise<MeetingsDailyTaskTeamsTeamDailyTasksListResponse> => {
    data = paginatedTeamDailyTaskListSchemaResponseTransformer(data);
    return data;
};

export const meetingsDailyTaskTeamsTeamDailyTasksRetrieveResponseTransformer = async (data: any): Promise<MeetingsDailyTaskTeamsTeamDailyTasksRetrieveResponse> => {
    data = teamDailyTaskSchemaResponseTransformer(data);
    return data;
};

const eventSchemaResponseTransformer = (data: any) => {
    data.start_date = new Date(data.start_date);
    data.end_date = new Date(data.end_date);
    if (data.enrollment_publication_publication_date) {
        data.enrollment_publication_publication_date = new Date(data.enrollment_publication_publication_date);
    }
    if (data.enrollment_publication_opening_date) {
        data.enrollment_publication_opening_date = new Date(data.enrollment_publication_opening_date);
    }
    if (data.enrollment_publication_closing_date) {
        data.enrollment_publication_closing_date = new Date(data.enrollment_publication_closing_date);
    }
    return data;
};

const paginatedEventListSchemaResponseTransformer = (data: any) => {
    data.results = data.results.map((item: any) => eventSchemaResponseTransformer(item));
    return data;
};

export const meetingsEventsListResponseTransformer = async (data: any): Promise<MeetingsEventsListResponse> => {
    data = paginatedEventListSchemaResponseTransformer(data);
    return data;
};

const notNestedEventSchemaResponseTransformer = (data: any) => {
    data.start_date = new Date(data.start_date);
    data.end_date = new Date(data.end_date);
    if (data.enrollment_publication_publication_date) {
        data.enrollment_publication_publication_date = new Date(data.enrollment_publication_publication_date);
    }
    if (data.enrollment_publication_opening_date) {
        data.enrollment_publication_opening_date = new Date(data.enrollment_publication_opening_date);
    }
    if (data.enrollment_publication_closing_date) {
        data.enrollment_publication_closing_date = new Date(data.enrollment_publication_closing_date);
    }
    return data;
};

export const meetingsEventsCreateResponseTransformer = async (data: any): Promise<MeetingsEventsCreateResponse> => {
    data = notNestedEventSchemaResponseTransformer(data);
    return data;
};

export const meetingsEventsWithActivityListResponseTransformer = async (data: any): Promise<MeetingsEventsWithActivityListResponse> => {
    data = paginatedEventListSchemaResponseTransformer(data);
    return data;
};

const eventWithActivitySchemaResponseTransformer = (data: any) => {
    data.start_date = new Date(data.start_date);
    data.end_date = new Date(data.end_date);
    if (data.enrollment_publication_publication_date) {
        data.enrollment_publication_publication_date = new Date(data.enrollment_publication_publication_date);
    }
    if (data.enrollment_publication_opening_date) {
        data.enrollment_publication_opening_date = new Date(data.enrollment_publication_opening_date);
    }
    if (data.enrollment_publication_closing_date) {
        data.enrollment_publication_closing_date = new Date(data.enrollment_publication_closing_date);
    }
    return data;
};

export const meetingsEventsWithActivityCreateResponseTransformer = async (data: any): Promise<MeetingsEventsWithActivityCreateResponse> => {
    data = eventWithActivitySchemaResponseTransformer(data);
    return data;
};

const notNestedEventWithNestedActivitySchemaResponseTransformer = (data: any) => {
    data.start_date = new Date(data.start_date);
    data.end_date = new Date(data.end_date);
    if (data.enrollment_publication_publication_date) {
        data.enrollment_publication_publication_date = new Date(data.enrollment_publication_publication_date);
    }
    if (data.enrollment_publication_opening_date) {
        data.enrollment_publication_opening_date = new Date(data.enrollment_publication_opening_date);
    }
    if (data.enrollment_publication_closing_date) {
        data.enrollment_publication_closing_date = new Date(data.enrollment_publication_closing_date);
    }
    return data;
};

export const meetingsEventsWithActivityRetrieveResponseTransformer = async (data: any): Promise<MeetingsEventsWithActivityRetrieveResponse> => {
    data = notNestedEventWithNestedActivitySchemaResponseTransformer(data);
    return data;
};

export const meetingsEventsWithActivityPartialUpdateResponseTransformer = async (data: any): Promise<MeetingsEventsWithActivityPartialUpdateResponse> => {
    data = notNestedEventWithNestedActivitySchemaResponseTransformer(data);
    return data;
};

export const meetingsEventsWithActivityUpdateResponseTransformer = async (data: any): Promise<MeetingsEventsWithActivityUpdateResponse> => {
    data = eventWithActivitySchemaResponseTransformer(data);
    return data;
};

export const meetingsEventsWithActivityChildrenRetrieveResponseTransformer = async (data: any): Promise<MeetingsEventsWithActivityChildrenRetrieveResponse> => {
    data = notNestedEventWithNestedActivitySchemaResponseTransformer(data);
    return data;
};

export const meetingsEventsWithActivityChildrenCreateResponseTransformer = async (data: any): Promise<MeetingsEventsWithActivityChildrenCreateResponse> => {
    data = eventSchemaResponseTransformer(data);
    return data;
};

const applyTypicalDaySchemaResponseTransformer = (data: any) => {
    data.days = data.days.map((item: any) => new Date(item));
    return data;
};

export const meetingsEventsWithActivityCopyToDaysCreateResponseTransformer = async (data: any): Promise<MeetingsEventsWithActivityCopyToDaysCreateResponse> => {
    data = applyTypicalDaySchemaResponseTransformer(data);
    return data;
};

const notNestedPublicEventParticipantEnrollmentSchemaResponseTransformer = (data: any) => {
    data.created_at = new Date(data.created_at);
    data.updated_at = new Date(data.updated_at);
    return data;
};

const paginatedNotNestedPublicEventParticipantEnrollmentListSchemaResponseTransformer = (data: any) => {
    data.results = data.results.map((item: any) => notNestedPublicEventParticipantEnrollmentSchemaResponseTransformer(item));
    return data;
};

export const meetingsEventsWithActivityEnrollmentListResponseTransformer = async (data: any): Promise<MeetingsEventsWithActivityEnrollmentListResponse> => {
    data = paginatedNotNestedPublicEventParticipantEnrollmentListSchemaResponseTransformer(data);
    return data;
};

export const meetingsEventsWithActivityEnrollmentCreateResponseTransformer = async (data: any): Promise<MeetingsEventsWithActivityEnrollmentCreateResponse> => {
    data = notNestedPublicEventParticipantEnrollmentSchemaResponseTransformer(data);
    return data;
};

export const meetingsEventsWithActivityMyEnrollmentRetrieveResponseTransformer = async (data: any): Promise<MeetingsEventsWithActivityMyEnrollmentRetrieveResponse> => {
    data = notNestedPublicEventParticipantEnrollmentSchemaResponseTransformer(data);
    return data;
};

export const meetingsEventsWithActivityMyEnrollmentCreateResponseTransformer = async (data: any): Promise<MeetingsEventsWithActivityMyEnrollmentCreateResponse> => {
    data = notNestedPublicEventParticipantEnrollmentSchemaResponseTransformer(data);
    return data;
};

export const meetingsEventsWithActivityApplyTypicalDayCreateResponseTransformer = async (data: any): Promise<MeetingsEventsWithActivityApplyTypicalDayCreateResponse> => {
    data = paginatedEventListSchemaResponseTransformer(data);
    return data;
};

export const meetingsEventsWithActivityEnrollmentsListResponseTransformer = async (data: any): Promise<MeetingsEventsWithActivityEnrollmentsListResponse> => {
    data = paginatedNotNestedPublicEventParticipantEnrollmentListSchemaResponseTransformer(data);
    return data;
};

const publicEventSchemaResponseTransformer = (data: any) => {
    data.start_date = new Date(data.start_date);
    data.end_date = new Date(data.end_date);
    return data;
};

const paginatedPublicEventListSchemaResponseTransformer = (data: any) => {
    data.results = data.results.map((item: any) => publicEventSchemaResponseTransformer(item));
    return data;
};

export const meetingsEventsWithActivityInChargeListResponseTransformer = async (data: any): Promise<MeetingsEventsWithActivityInChargeListResponse> => {
    data = paginatedPublicEventListSchemaResponseTransformer(data);
    return data;
};

export const meetingsEventsWithActivityMyDailyEventsListResponseTransformer = async (data: any): Promise<MeetingsEventsWithActivityMyDailyEventsListResponse> => {
    data = paginatedPublicEventListSchemaResponseTransformer(data);
    return data;
};

export const meetingsEventsWithActivityMyEnrollmentsListResponseTransformer = async (data: any): Promise<MeetingsEventsWithActivityMyEnrollmentsListResponse> => {
    data = paginatedNotNestedPublicEventParticipantEnrollmentListSchemaResponseTransformer(data);
    return data;
};

export const meetingsEventsWithActivityOwnPlanningListResponseTransformer = async (data: any): Promise<MeetingsEventsWithActivityOwnPlanningListResponse> => {
    data = paginatedPublicEventListSchemaResponseTransformer(data);
    return data;
};

export const meetingsEventsWithActivityPlanningRetrieveResponseTransformer = async (data: any): Promise<MeetingsEventsWithActivityPlanningRetrieveResponse> => {
    data = notNestedEventWithNestedActivitySchemaResponseTransformer(data);
    return data;
};

export const meetingsEventsWithActivityPublicListListResponseTransformer = async (data: any): Promise<MeetingsEventsWithActivityPublicListListResponse> => {
    data = paginatedPublicEventListSchemaResponseTransformer(data);
    return data;
};

export const meetingsEventsWithActivitySupervisorListResponseTransformer = async (data: any): Promise<MeetingsEventsWithActivitySupervisorListResponse> => {
    data = paginatedPublicEventListSchemaResponseTransformer(data);
    return data;
};

export const meetingsEventsWithActivityTypicalDayListResponseTransformer = async (data: any): Promise<MeetingsEventsWithActivityTypicalDayListResponse> => {
    data = paginatedPublicEventListSchemaResponseTransformer(data);
    return data;
};

export const meetingsEventsRetrieveResponseTransformer = async (data: any): Promise<MeetingsEventsRetrieveResponse> => {
    data = notNestedEventSchemaResponseTransformer(data);
    return data;
};

export const meetingsEventsPartialUpdateResponseTransformer = async (data: any): Promise<MeetingsEventsPartialUpdateResponse> => {
    data = notNestedEventSchemaResponseTransformer(data);
    return data;
};

export const meetingsEventsUpdateResponseTransformer = async (data: any): Promise<MeetingsEventsUpdateResponse> => {
    data = notNestedEventSchemaResponseTransformer(data);
    return data;
};

export const meetingsEventsChildrenRetrieveResponseTransformer = async (data: any): Promise<MeetingsEventsChildrenRetrieveResponse> => {
    data = notNestedEventSchemaResponseTransformer(data);
    return data;
};

export const meetingsEventsChildrenCreateResponseTransformer = async (data: any): Promise<MeetingsEventsChildrenCreateResponse> => {
    data = eventSchemaResponseTransformer(data);
    return data;
};

export const meetingsEventsCopyToDaysCreateResponseTransformer = async (data: any): Promise<MeetingsEventsCopyToDaysCreateResponse> => {
    data = applyTypicalDaySchemaResponseTransformer(data);
    return data;
};

export const meetingsEventsEnrollmentListResponseTransformer = async (data: any): Promise<MeetingsEventsEnrollmentListResponse> => {
    data = paginatedNotNestedPublicEventParticipantEnrollmentListSchemaResponseTransformer(data);
    return data;
};

export const meetingsEventsEnrollmentCreateResponseTransformer = async (data: any): Promise<MeetingsEventsEnrollmentCreateResponse> => {
    data = notNestedPublicEventParticipantEnrollmentSchemaResponseTransformer(data);
    return data;
};

export const meetingsEventsMyEnrollmentRetrieveResponseTransformer = async (data: any): Promise<MeetingsEventsMyEnrollmentRetrieveResponse> => {
    data = notNestedPublicEventParticipantEnrollmentSchemaResponseTransformer(data);
    return data;
};

export const meetingsEventsMyEnrollmentCreateResponseTransformer = async (data: any): Promise<MeetingsEventsMyEnrollmentCreateResponse> => {
    data = notNestedPublicEventParticipantEnrollmentSchemaResponseTransformer(data);
    return data;
};

export const meetingsEventsApplyTypicalDayCreateResponseTransformer = async (data: any): Promise<MeetingsEventsApplyTypicalDayCreateResponse> => {
    data = paginatedEventListSchemaResponseTransformer(data);
    return data;
};

export const meetingsEventsEnrollmentsListResponseTransformer = async (data: any): Promise<MeetingsEventsEnrollmentsListResponse> => {
    data = paginatedNotNestedPublicEventParticipantEnrollmentListSchemaResponseTransformer(data);
    return data;
};

export const meetingsEventsInChargeListResponseTransformer = async (data: any): Promise<MeetingsEventsInChargeListResponse> => {
    data = paginatedPublicEventListSchemaResponseTransformer(data);
    return data;
};

const modularEventSchemaResponseTransformer = (data: any) => {
    data.start_date = new Date(data.start_date);
    data.end_date = new Date(data.end_date);
    data.modular_children = data.modular_children.map((item: any) => eventWithActivitySchemaResponseTransformer(item));
    return data;
};

const paginatedModularEventListSchemaResponseTransformer = (data: any) => {
    data.results = data.results.map((item: any) => modularEventSchemaResponseTransformer(item));
    return data;
};

export const meetingsEventsModularListResponseTransformer = async (data: any): Promise<MeetingsEventsModularListResponse> => {
    data = paginatedModularEventListSchemaResponseTransformer(data);
    return data;
};

export const meetingsEventsMyDailyEventsListResponseTransformer = async (data: any): Promise<MeetingsEventsMyDailyEventsListResponse> => {
    data = paginatedPublicEventListSchemaResponseTransformer(data);
    return data;
};

export const meetingsEventsMyEnrollmentsListResponseTransformer = async (data: any): Promise<MeetingsEventsMyEnrollmentsListResponse> => {
    data = paginatedNotNestedPublicEventParticipantEnrollmentListSchemaResponseTransformer(data);
    return data;
};

export const meetingsEventsOwnPlanningListResponseTransformer = async (data: any): Promise<MeetingsEventsOwnPlanningListResponse> => {
    data = paginatedPublicEventListSchemaResponseTransformer(data);
    return data;
};

export const meetingsEventsPlanningRetrieveResponseTransformer = async (data: any): Promise<MeetingsEventsPlanningRetrieveResponse> => {
    data = notNestedEventSchemaResponseTransformer(data);
    return data;
};

export const meetingsEventsPublicListListResponseTransformer = async (data: any): Promise<MeetingsEventsPublicListListResponse> => {
    data = paginatedPublicEventListSchemaResponseTransformer(data);
    return data;
};

const publicModularEventSchemaResponseTransformer = (data: any) => {
    data.start_date = new Date(data.start_date);
    data.end_date = new Date(data.end_date);
    data.modular_children = data.modular_children.map((item: any) => publicEventSchemaResponseTransformer(item));
    return data;
};

const paginatedPublicModularEventListSchemaResponseTransformer = (data: any) => {
    data.results = data.results.map((item: any) => publicModularEventSchemaResponseTransformer(item));
    return data;
};

export const meetingsEventsPublicModularListResponseTransformer = async (data: any): Promise<MeetingsEventsPublicModularListResponse> => {
    data = paginatedPublicModularEventListSchemaResponseTransformer(data);
    return data;
};

export const meetingsEventsSupervisorListResponseTransformer = async (data: any): Promise<MeetingsEventsSupervisorListResponse> => {
    data = paginatedPublicEventListSchemaResponseTransformer(data);
    return data;
};

export const meetingsEventsTypicalDayListResponseTransformer = async (data: any): Promise<MeetingsEventsTypicalDayListResponse> => {
    data = paginatedPublicEventListSchemaResponseTransformer(data);
    return data;
};

const meetingFormSchemaResponseTransformer = (data: any) => {
    data.created_at = new Date(data.created_at);
    data.updated_at = new Date(data.updated_at);
    if (data.publication_date) {
        data.publication_date = new Date(data.publication_date);
    }
    if (data.opening_date) {
        data.opening_date = new Date(data.opening_date);
    }
    if (data.closing_date) {
        data.closing_date = new Date(data.closing_date);
    }
    return data;
};

export const meetingsFormsListResponseTransformer = async (data: any): Promise<MeetingsFormsListResponse> => {
    data = data.map((item: any) => meetingFormSchemaResponseTransformer(item));
    return data;
};

const notNestedMeetingFormSchemaResponseTransformer = (data: any) => {
    data.created_at = new Date(data.created_at);
    data.updated_at = new Date(data.updated_at);
    if (data.publication_date) {
        data.publication_date = new Date(data.publication_date);
    }
    if (data.opening_date) {
        data.opening_date = new Date(data.opening_date);
    }
    if (data.closing_date) {
        data.closing_date = new Date(data.closing_date);
    }
    return data;
};

export const meetingsFormsCreateResponseTransformer = async (data: any): Promise<MeetingsFormsCreateResponse> => {
    data = notNestedMeetingFormSchemaResponseTransformer(data);
    return data;
};

const meetingPublicFormSchemaResponseTransformer = (data: any) => {
    if (data.publication_date) {
        data.publication_date = new Date(data.publication_date);
    }
    if (data.opening_date) {
        data.opening_date = new Date(data.opening_date);
    }
    if (data.closing_date) {
        data.closing_date = new Date(data.closing_date);
    }
    return data;
};

export const meetingsFormsPublicListResponseTransformer = async (data: any): Promise<MeetingsFormsPublicListResponse> => {
    data = data.map((item: any) => meetingPublicFormSchemaResponseTransformer(item));
    return data;
};

const meetingFormSubmissionSchemaResponseTransformer = (data: any) => {
    data.submitted_at = new Date(data.submitted_at);
    return data;
};

const meetingPublicFormWithFieldsSchemaResponseTransformer = (data: any) => {
    if (data.publication_date) {
        data.publication_date = new Date(data.publication_date);
    }
    data.form_responses = data.form_responses.map((item: any) => meetingFormSubmissionSchemaResponseTransformer(item));
    if (data.opening_date) {
        data.opening_date = new Date(data.opening_date);
    }
    if (data.closing_date) {
        data.closing_date = new Date(data.closing_date);
    }
    return data;
};

export const meetingsFormsPublicRetrieveResponseTransformer = async (data: any): Promise<MeetingsFormsPublicRetrieveResponse> => {
    data = meetingPublicFormWithFieldsSchemaResponseTransformer(data);
    return data;
};

export const meetingsFormsSubmissionsListResponseTransformer = async (data: any): Promise<MeetingsFormsSubmissionsListResponse> => {
    data = data.map((item: any) => meetingFormSubmissionSchemaResponseTransformer(item));
    return data;
};

const notNestedMeetingFormSubmissionSchemaResponseTransformer = (data: any) => {
    data.submitted_at = new Date(data.submitted_at);
    return data;
};

export const meetingsFormsSubmissionsCreateResponseTransformer = async (data: any): Promise<MeetingsFormsSubmissionsCreateResponse> => {
    data = notNestedMeetingFormSubmissionSchemaResponseTransformer(data);
    return data;
};

export const meetingsFormsSubmissionsRetrieveResponseTransformer = async (data: any): Promise<MeetingsFormsSubmissionsRetrieveResponse> => {
    data = meetingFormSubmissionSchemaResponseTransformer(data);
    return data;
};

export const meetingsFormsSubmissionsPartialUpdateResponseTransformer = async (data: any): Promise<MeetingsFormsSubmissionsPartialUpdateResponse> => {
    data = meetingFormSubmissionSchemaResponseTransformer(data);
    return data;
};

export const meetingsFormsSubmissionsUpdateResponseTransformer = async (data: any): Promise<MeetingsFormsSubmissionsUpdateResponse> => {
    data = meetingFormSubmissionSchemaResponseTransformer(data);
    return data;
};

export const meetingsFormsRetrieveResponseTransformer = async (data: any): Promise<MeetingsFormsRetrieveResponse> => {
    data = meetingFormSchemaResponseTransformer(data);
    return data;
};

export const meetingsFormsPartialUpdateResponseTransformer = async (data: any): Promise<MeetingsFormsPartialUpdateResponse> => {
    data = meetingFormSchemaResponseTransformer(data);
    return data;
};

export const meetingsFormsUpdateResponseTransformer = async (data: any): Promise<MeetingsFormsUpdateResponse> => {
    data = notNestedMeetingFormSchemaResponseTransformer(data);
    return data;
};

const meetingFormSubmissionExportSchemaResponseTransformer = (data: any) => {
    data.submitted_at = new Date(data.submitted_at);
    return data;
};

export const meetingsFormsExportSubmissionsRetrieveResponseTransformer = async (data: any): Promise<MeetingsFormsExportSubmissionsRetrieveResponse> => {
    data = meetingFormSubmissionExportSchemaResponseTransformer(data);
    return data;
};

const publishMeetingFormSchemaResponseTransformer = (data: any) => {
    if (data.publication_date) {
        data.publication_date = new Date(data.publication_date);
    }
    if (data.opening_date) {
        data.opening_date = new Date(data.opening_date);
    }
    if (data.closing_date) {
        data.closing_date = new Date(data.closing_date);
    }
    return data;
};

export const meetingsFormsPublishCreateResponseTransformer = async (data: any): Promise<MeetingsFormsPublishCreateResponse> => {
    data = publishMeetingFormSchemaResponseTransformer(data);
    return data;
};

const noCommentMeetingParticipantSchemaResponseTransformer = (data: any) => {
    data.created = new Date(data.created);
    data.updated = new Date(data.updated);
    data.user = notNestedUserSchemaResponseTransformer(data.user);
    if (data.birthdate) {
        data.birthdate = new Date(data.birthdate);
    }
    if (data.tagada_avis_last_sync) {
        data.tagada_avis_last_sync = new Date(data.tagada_avis_last_sync);
    }
    data.intranet_last_sync = new Date(data.intranet_last_sync);
    return data;
};

const paginatedNoCommentMeetingParticipantListSchemaResponseTransformer = (data: any) => {
    data.results = data.results.map((item: any) => noCommentMeetingParticipantSchemaResponseTransformer(item));
    return data;
};

export const meetingsParticipantsListResponseTransformer = async (data: any): Promise<MeetingsParticipantsListResponse> => {
    data = paginatedNoCommentMeetingParticipantListSchemaResponseTransformer(data);
    return data;
};

export const meetingsParticipantsRetrieveResponseTransformer = async (data: any): Promise<MeetingsParticipantsRetrieveResponse> => {
    data = meetingParticipantSchemaResponseTransformer(data);
    return data;
};

export const meetingsParticipantsPartialUpdateResponseTransformer = async (data: any): Promise<MeetingsParticipantsPartialUpdateResponse> => {
    data = meetingParticipantSchemaResponseTransformer(data);
    return data;
};

export const meetingsParticipantsUpdateResponseTransformer = async (data: any): Promise<MeetingsParticipantsUpdateResponse> => {
    data = meetingParticipantSchemaResponseTransformer(data);
    return data;
};

export const meetingsParticipantsAvatarMediaRetrieveResponseTransformer = async (data: any): Promise<MeetingsParticipantsAvatarMediaRetrieveResponse> => {
    data = meetingParticipantSchemaResponseTransformer(data);
    return data;
};

export const meetingsParticipantsAvatarMediaUpdateResponseTransformer = async (data: any): Promise<MeetingsParticipantsAvatarMediaUpdateResponse> => {
    data = meetingParticipantSchemaResponseTransformer(data);
    return data;
};

const nestedMeetingCommentDetailSchemaResponseTransformer = (data: any) => {
    data.updated_at = new Date(data.updated_at);
    return data;
};

const opinionParticipantSchemaResponseTransformer = (data: any) => {
    if (data.js_opinion) {
        data.js_opinion = nestedMeetingCommentDetailSchemaResponseTransformer(data.js_opinion);
    }
    if (data.sgdf_opinion) {
        data.sgdf_opinion = nestedMeetingCommentDetailSchemaResponseTransformer(data.sgdf_opinion);
    }
    return data;
};

export const meetingsParticipantsOpinionRetrieveResponseTransformer = async (data: any): Promise<MeetingsParticipantsOpinionRetrieveResponse> => {
    data = opinionParticipantSchemaResponseTransformer(data);
    return data;
};

export const meetingsParticipantsOpinionPartialUpdateResponseTransformer = async (data: any): Promise<MeetingsParticipantsOpinionPartialUpdateResponse> => {
    data = opinionParticipantSchemaResponseTransformer(data);
    return data;
};

export const meetingsParticipantsOpinionUpdateResponseTransformer = async (data: any): Promise<MeetingsParticipantsOpinionUpdateResponse> => {
    data = opinionParticipantSchemaResponseTransformer(data);
    return data;
};

export const meetingsParticipantsSignatureMediaRetrieveResponseTransformer = async (data: any): Promise<MeetingsParticipantsSignatureMediaRetrieveResponse> => {
    data = meetingParticipantSchemaResponseTransformer(data);
    return data;
};

export const meetingsParticipantsSignatureMediaUpdateResponseTransformer = async (data: any): Promise<MeetingsParticipantsSignatureMediaUpdateResponse> => {
    data = meetingParticipantSchemaResponseTransformer(data);
    return data;
};

const meetingCommentSchemaResponseTransformer = (data: any) => {
    data.created_at = new Date(data.created_at);
    data.date = new Date(data.date);
    return data;
};

const paginatedMeetingCommentListSchemaResponseTransformer = (data: any) => {
    data.results = data.results.map((item: any) => meetingCommentSchemaResponseTransformer(item));
    return data;
};

export const meetingsParticipantsCommentsListResponseTransformer = async (data: any): Promise<MeetingsParticipantsCommentsListResponse> => {
    data = paginatedMeetingCommentListSchemaResponseTransformer(data);
    return data;
};

export const meetingsParticipantsCommentsCreateResponseTransformer = async (data: any): Promise<MeetingsParticipantsCommentsCreateResponse> => {
    data = meetingCommentSchemaResponseTransformer(data);
    return data;
};

export const meetingsParticipantsCommentsRetrieveResponseTransformer = async (data: any): Promise<MeetingsParticipantsCommentsRetrieveResponse> => {
    data = meetingCommentSchemaResponseTransformer(data);
    return data;
};

export const meetingsParticipantsCommentsPartialUpdateResponseTransformer = async (data: any): Promise<MeetingsParticipantsCommentsPartialUpdateResponse> => {
    data = meetingCommentSchemaResponseTransformer(data);
    return data;
};

export const meetingsParticipantsCommentsUpdateResponseTransformer = async (data: any): Promise<MeetingsParticipantsCommentsUpdateResponse> => {
    data = meetingCommentSchemaResponseTransformer(data);
    return data;
};

const paginatedOpinionParticipantListSchemaResponseTransformer = (data: any) => {
    data.results = data.results.map((item: any) => opinionParticipantSchemaResponseTransformer(item));
    return data;
};

export const meetingsParticipantsOpinionListListResponseTransformer = async (data: any): Promise<MeetingsParticipantsOpinionListListResponse> => {
    data = paginatedOpinionParticipantListSchemaResponseTransformer(data);
    return data;
};

const publicNotNestedResourceSchemaResponseTransformer = (data: any) => {
    if (data.publication_date) {
        data.publication_date = new Date(data.publication_date);
    }
    return data;
};

export const meetingsResourcesCreateResponseTransformer = async (data: any): Promise<MeetingsResourcesCreateResponse> => {
    data = publicNotNestedResourceSchemaResponseTransformer(data);
    return data;
};

export const meetingsResourcesPublicCreateResponseTransformer = async (data: any): Promise<MeetingsResourcesPublicCreateResponse> => {
    data = publicNotNestedResourceSchemaResponseTransformer(data);
    return data;
};

export const meetingsResourcesPublicRetrieveResponseTransformer = async (data: any): Promise<MeetingsResourcesPublicRetrieveResponse> => {
    data = publicNotNestedResourceSchemaResponseTransformer(data);
    return data;
};

export const meetingsResourcesPublicPartialUpdateResponseTransformer = async (data: any): Promise<MeetingsResourcesPublicPartialUpdateResponse> => {
    data = publicNotNestedResourceSchemaResponseTransformer(data);
    return data;
};

const createPublicNotNestedResourceSchemaResponseTransformer = (data: any) => {
    if (data.publication_date) {
        data.publication_date = new Date(data.publication_date);
    }
    return data;
};

export const meetingsResourcesPublicUpdateResponseTransformer = async (data: any): Promise<MeetingsResourcesPublicUpdateResponse> => {
    data = createPublicNotNestedResourceSchemaResponseTransformer(data);
    return data;
};

export const meetingsResourcesPublicResourceMediaRetrieveResponseTransformer = async (data: any): Promise<MeetingsResourcesPublicResourceMediaRetrieveResponse> => {
    data = publicNotNestedResourceSchemaResponseTransformer(data);
    return data;
};

export const meetingsResourcesPublicResourceMediaUpdateResponseTransformer = async (data: any): Promise<MeetingsResourcesPublicResourceMediaUpdateResponse> => {
    data = publicNotNestedResourceSchemaResponseTransformer(data);
    return data;
};

const resourceNodeSchemaResponseTransformer = (data: any) => {
    data.children = data.children.map((item: any) => resourceNodeSchemaResponseTransformer(item));
    return data;
};

const publicResourceTreeListSchemaResponseTransformer = (data: any) => {
    data.tree = data.tree.map((item: any) => resourceNodeSchemaResponseTransformer(item));
    data.list = data.list.map((item: any) => publicNotNestedResourceSchemaResponseTransformer(item));
    return data;
};

export const meetingsResourcesPublicTreeRetrieveResponseTransformer = async (data: any): Promise<MeetingsResourcesPublicTreeRetrieveResponse> => {
    data = publicResourceTreeListSchemaResponseTransformer(data);
    return data;
};

const notNestedResourceSchemaResponseTransformer = (data: any) => {
    if (data.publication_date) {
        data.publication_date = new Date(data.publication_date);
    }
    return data;
};

export const meetingsResourcesRetrieveResponseTransformer = async (data: any): Promise<MeetingsResourcesRetrieveResponse> => {
    data = notNestedResourceSchemaResponseTransformer(data);
    return data;
};

export const meetingsResourcesPartialUpdateResponseTransformer = async (data: any): Promise<MeetingsResourcesPartialUpdateResponse> => {
    data = notNestedResourceSchemaResponseTransformer(data);
    return data;
};

const createNotNestedResourceSchemaResponseTransformer = (data: any) => {
    if (data.publication_date) {
        data.publication_date = new Date(data.publication_date);
    }
    return data;
};

export const meetingsResourcesUpdateResponseTransformer = async (data: any): Promise<MeetingsResourcesUpdateResponse> => {
    data = createNotNestedResourceSchemaResponseTransformer(data);
    return data;
};

export const meetingsResourcesResourceMediaRetrieveResponseTransformer = async (data: any): Promise<MeetingsResourcesResourceMediaRetrieveResponse> => {
    data = notNestedResourceSchemaResponseTransformer(data);
    return data;
};

export const meetingsResourcesResourceMediaUpdateResponseTransformer = async (data: any): Promise<MeetingsResourcesResourceMediaUpdateResponse> => {
    data = notNestedResourceSchemaResponseTransformer(data);
    return data;
};

const resourceTreeListSchemaResponseTransformer = (data: any) => {
    data.tree = data.tree.map((item: any) => resourceNodeSchemaResponseTransformer(item));
    data.list = data.list.map((item: any) => notNestedResourceSchemaResponseTransformer(item));
    return data;
};

export const meetingsResourcesTreeRetrieveResponseTransformer = async (data: any): Promise<MeetingsResourcesTreeRetrieveResponse> => {
    data = resourceTreeListSchemaResponseTransformer(data);
    return data;
};

const participantListSchemaResponseTransformer = (data: any) => {
    data.birthdate = new Date(data.birthdate);
    return data;
};

export const meetingsTableExportsParticipantListRetrieveResponseTransformer = async (data: any): Promise<MeetingsTableExportsParticipantListRetrieveResponse> => {
    data = participantListSchemaResponseTransformer(data);
    return data;
};

const participantListDirectionSchemaResponseTransformer = (data: any) => {
    data.start_date = new Date(data.start_date);
    data.end_date = new Date(data.end_date);
    data.date_de_debut = new Date(data.date_de_debut);
    data.date_de_fin = new Date(data.date_de_fin);
    data.birthdate = new Date(data.birthdate);
    return data;
};

export const meetingsTableExportsParticipantListDirectionRetrieveResponseTransformer = async (data: any): Promise<MeetingsTableExportsParticipantListDirectionRetrieveResponse> => {
    data = participantListDirectionSchemaResponseTransformer(data);
    return data;
};

const pvSchemaResponseTransformer = (data: any) => {
    data.date_de_debut = new Date(data.date_de_debut);
    data.date_de_fin = new Date(data.date_de_fin);
    data.birthdate = new Date(data.birthdate);
    return data;
};

export const meetingsTableExportsProcesVerbalRetrieveResponseTransformer = async (data: any): Promise<MeetingsTableExportsProcesVerbalRetrieveResponse> => {
    data = pvSchemaResponseTransformer(data);
    return data;
};

const pandasTeamDailyTaskByTaskSchemaResponseTransformer = (data: any) => {
    data.date = new Date(data.date);
    return data;
};

export const meetingsTableExportsTeamsdailytasksbytaskRetrieveResponseTransformer = async (data: any): Promise<MeetingsTableExportsTeamsdailytasksbytaskRetrieveResponse> => {
    data = pandasTeamDailyTaskByTaskSchemaResponseTransformer(data);
    return data;
};

const pandasTeamDailyTaskByTeamSchemaResponseTransformer = (data: any) => {
    data.date = new Date(data.date);
    return data;
};

export const meetingsTableExportsTeamsdailytasksbyteamRetrieveResponseTransformer = async (data: any): Promise<MeetingsTableExportsTeamsdailytasksbyteamRetrieveResponse> => {
    data = pandasTeamDailyTaskByTeamSchemaResponseTransformer(data);
    return data;
};

export const meetingsTeamDailyTasksListResponseTransformer = async (data: any): Promise<MeetingsTeamDailyTasksListResponse> => {
    data = data.map((item: any) => teamDailyTaskSchemaResponseTransformer(item));
    return data;
};

export const meetingsTeamDailyTasksCreateResponseTransformer = async (data: any): Promise<MeetingsTeamDailyTasksCreateResponse> => {
    data = teamDailyTaskSchemaResponseTransformer(data);
    return data;
};

export const meetingsTeamDailyTasksRetrieveResponseTransformer = async (data: any): Promise<MeetingsTeamDailyTasksRetrieveResponse> => {
    data = teamDailyTaskSchemaResponseTransformer(data);
    return data;
};

export const meetingsTeamDailyTasksPartialUpdateResponseTransformer = async (data: any): Promise<MeetingsTeamDailyTasksPartialUpdateResponse> => {
    data = teamDailyTaskSchemaResponseTransformer(data);
    return data;
};

export const meetingsTeamDailyTasksUpdateResponseTransformer = async (data: any): Promise<MeetingsTeamDailyTasksUpdateResponse> => {
    data = teamDailyTaskSchemaResponseTransformer(data);
    return data;
};

export const participantsExportsProcesVerbalRetrieveResponseTransformer = async (data: any): Promise<ParticipantsExportsProcesVerbalRetrieveResponse> => {
    data = pvSchemaResponseTransformer(data);
    return data;
};

const readOnlyNotNestedUserSchemaResponseTransformer = (data: any) => {
    if (data.birthdate) {
        data.birthdate = new Date(data.birthdate);
    }
    data.diplomas = data.diplomas.map((item: any) => notNestedDiplomaSchemaResponseTransformer(item));
    if (data.last_sync) {
        data.last_sync = new Date(data.last_sync);
    }
    return data;
};

export const usersRetrieveResponseTransformer = async (data: any): Promise<UsersRetrieveResponse> => {
    data = readOnlyNotNestedUserSchemaResponseTransformer(data);
    return data;
};

export const usersAvatarMediaRetrieveResponseTransformer = async (data: any): Promise<UsersAvatarMediaRetrieveResponse> => {
    data = readOnlyNotNestedUserSchemaResponseTransformer(data);
    return data;
};

export const usersAvatarMediaUpdateResponseTransformer = async (data: any): Promise<UsersAvatarMediaUpdateResponse> => {
    data = readOnlyNotNestedUserSchemaResponseTransformer(data);
    return data;
};

export const usersSignatureMediaRetrieveResponseTransformer = async (data: any): Promise<UsersSignatureMediaRetrieveResponse> => {
    data = readOnlyNotNestedUserSchemaResponseTransformer(data);
    return data;
};

export const usersSignatureMediaUpdateResponseTransformer = async (data: any): Promise<UsersSignatureMediaUpdateResponse> => {
    data = readOnlyNotNestedUserSchemaResponseTransformer(data);
    return data;
};

export const usersDiplomasListResponseTransformer = async (data: any): Promise<UsersDiplomasListResponse> => {
    data = data.map((item: any) => notNestedDiplomaSchemaResponseTransformer(item));
    return data;
};

export const usersDiplomasCreateResponseTransformer = async (data: any): Promise<UsersDiplomasCreateResponse> => {
    data = notNestedDiplomaSchemaResponseTransformer(data);
    return data;
};

export const usersDiplomasRetrieveResponseTransformer = async (data: any): Promise<UsersDiplomasRetrieveResponse> => {
    data = notNestedDiplomaSchemaResponseTransformer(data);
    return data;
};

export const usersDiplomasPartialUpdateResponseTransformer = async (data: any): Promise<UsersDiplomasPartialUpdateResponse> => {
    data = notNestedDiplomaSchemaResponseTransformer(data);
    return data;
};

export const usersDiplomasUpdateResponseTransformer = async (data: any): Promise<UsersDiplomasUpdateResponse> => {
    data = notNestedDiplomaSchemaResponseTransformer(data);
    return data;
};

export const usersDiplomasDiplomaMediaRetrieveResponseTransformer = async (data: any): Promise<UsersDiplomasDiplomaMediaRetrieveResponse> => {
    data = notNestedDiplomaSchemaResponseTransformer(data);
    return data;
};

export const usersDiplomasDiplomaMediaUpdateResponseTransformer = async (data: any): Promise<UsersDiplomasDiplomaMediaUpdateResponse> => {
    data = notNestedDiplomaSchemaResponseTransformer(data);
    return data;
};

const sgdfUserDetailsSchemaResponseTransformer = (data: any) => {
    if (data.birthdate) {
        data.birthdate = new Date(data.birthdate);
    }
    data.participations = data.participations.map((item: any) => ownMeetingParticipantSchemaResponseTransformer(item));
    data.diplomas = data.diplomas.map((item: any) => notNestedDiplomaSchemaResponseTransformer(item));
    if (data.last_sync) {
        data.last_sync = new Date(data.last_sync);
    }
    return data;
};

export const usersMeRetrieveResponseTransformer = async (data: any): Promise<UsersMeRetrieveResponse> => {
    data = sgdfUserDetailsSchemaResponseTransformer(data);
    return data;
};

const readonlyMeetingSchemaResponseTransformer = (data: any) => {
    data.created_at = new Date(data.created_at);
    data.end_date = new Date(data.end_date);
    data.start_date = new Date(data.start_date);
    data.updated_at = new Date(data.updated_at);
    if (data.tagada_participants_last_sync) {
        data.tagada_participants_last_sync = new Date(data.tagada_participants_last_sync);
    }
    if (data.tagada_avis_last_sync) {
        data.tagada_avis_last_sync = new Date(data.tagada_avis_last_sync);
    }
    data.intranet_last_sync = new Date(data.intranet_last_sync);
    return data;
};

export const webhooksCronMeetingCreateResponseTransformer = async (data: any): Promise<WebhooksCronMeetingCreateResponse> => {
    data = readonlyMeetingSchemaResponseTransformer(data);
    return data;
};

export const webhooksCronMeetingParticipantCreateResponseTransformer = async (data: any): Promise<WebhooksCronMeetingParticipantCreateResponse> => {
    data = readonlyMeetingSchemaResponseTransformer(data);
    return data;
};
